import { useRef, useCallback } from 'react'
import { logger } from '@/lib/logger'
import type { OnboardingStep } from './types'

interface CompletionMetrics {
  mealsAdded: number
  slotsFilled: number
}

export function useOnboardingInstrumentation() {
  const startTimestamp = useRef<number>(Date.now())

  const recordCompletion = useCallback((metrics: CompletionMetrics) => {
    const durationSeconds = Math.round((Date.now() - startTimestamp.current) / 1000)
    logger.info('onboarding_complete', {
      event: 'onboarding_complete',
      duration_seconds: durationSeconds,
      meals_added: metrics.mealsAdded,
      slots_filled: metrics.slotsFilled,
      within_target: durationSeconds <= 300,
    })
  }, [])

  const recordStepEntered = useCallback((step: OnboardingStep) => {
    const elapsedSeconds = Math.round((Date.now() - startTimestamp.current) / 1000)
    logger.info('onboarding_step_entered', {
      event: 'onboarding_step_entered',
      step,
      elapsed_seconds: elapsedSeconds,
    })
  }, [])

  const recordResumed = useCallback((step: OnboardingStep) => {
    logger.info('onboarding_resumed', {
      event: 'onboarding_resumed',
      step,
    })
  }, [])

  return { recordCompletion, recordStepEntered, recordResumed }
}
